// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3PQHm","name":"Header_name__2Olqh","birthday":"Header_birthday__yt1Ii","skeleton":"Header_skeleton__XZ_7X"};